import React from 'react';
import classNames from 'classnames';

interface ButtonProps {
    type: 'submit' | 'button' | 'reset';
    status: 'idle' | 'sending' | 'sent' | 'error';
    text: string;
    disabled?: boolean;
    icon?: any;  
    link?: string;     
    className?: string;
}

const Button: React.FC<ButtonProps> = ({ type, status, text, disabled, icon: Icon, link, className }) => {
    const handleClick = () => {
        if (link) {
            window.open(link, '_blank')
        }
    }

    const buttonClassNames = classNames(
        className ,
        'items-center w-full px-12 py-4 text-sm lg:w-auto lg:text-md lg:px-12 lg:py-4 text-black font-bold',
        {
            'bg-gray-500 cursor-not-allowed': status === 'sending',
            'bg-white hover:bg-gray-200': status !== 'sending',
        },
    )

    return (
        <button
            type={type}
            className={buttonClassNames}
            disabled={status === 'sending' || disabled}
            onClick={handleClick} 
        >
            {Icon && (
                <Icon className='w-5 h-5' /> 
            )}
            {status === 'sending' ? 'Sending...' : text}
        </button>
    )
};

export default Button;
